// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const Modal = require('client-v2/common/components/modal')
// Convenience helpers
const { createElement: tag } = React

const bem = BemEntity('StumbleUponSubmitModal')

function StumbleUponSubmitModal(props) {
  if (!props.isVisible) {
    return null
  }
  return tag(Modal, {
    className: bem.block(),
    onDismiss: props.onDismiss
  },
    tag('div', {
      className: bem.element('caption')
    },
      'Nice find!'
    ),
    tag('div', {
      className: bem.element('heading')
    },
      'Hi! StumbleUpon has moved to Mix'
    ),
    tag('div', {
      className: bem.element('image')
    }),
    tag('div', {
      className: bem.element('paragraph')
    },
      'Mix lets you curate and discover the best of the web. ',
      'Save and share articles, videos, and images from across the Internet.'
    ),
    props.addHref && tag('div', {
      className: bem.element('paragraph')
    },
      `Sign up to add `,
      tag('a', {
        className: bem.element('href'),
        href: props.addHref,
        rel: 'nofollow noopener',
        target: '_blank'
      },
        props.addHref
      ),
      ` to your first collection.`
    ),
    tag(CapsuleButton, {
      className: bem.element('button'),
      onClick: props.onSignupClick
    },
      'Sign up & Add to Mix'
    ),
    tag('div', {
      className: bem.element('bottom-text')
    },
      `Already have a Mix account? `,
      tag('button', {
        className: bem.element('bottom-action'),
        onClick: props.onLoginClick
      },
        `Sign in`
      ),
      `.`
    )
  )
}

StumbleUponSubmitModal.propTypes = {
  // Flags
  isVisible: PropTypes.bool,
  // Values
  addHref: PropTypes.string,
  // Callbacks
  onDismiss: PropTypes.func,
  onLoginClick: PropTypes.func,
  onSignupClick: PropTypes.func
}

module.exports = StumbleUponSubmitModal
